import { get } from './http'

export function getPeople() {
  // 人才理念
  return get('/api/singlepage/joinus')
}

export function getJob() {
  // 招聘动态
  return get('/api/job/jobs')
}

export function getConcat() {
  // 联系我们
  return get('/api/job/contactus')
}
